
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from './alert.service';
import { environment } from '../../environments/environment';
import { StatusProtocolo } from '../_models';

@Injectable({
    providedIn: 'root'
})

export class StatusProtocoloService {

    getStatusProtocolo(): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/StatusProtocolo`;
        return this.http.get<StatusProtocolo[]>(apiURL);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }
}
